/* @flow */

import * as React from 'react';
import useSheet from 'app/jss';
import { noop } from 'lodash/fp';
import { hover } from 'app/utils/cssUtils';
import classNames from 'classnames';
import Icon from 'app/components/commons/Icon';
import RewriteLink from 'app/components/routing/RewriteLink';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  children?: any,
  className?: string,
  classes: Object,
  disabled?: boolean,
  icon?: string,
  link?: string,
  onClick?: () => void,
  onItemClick?: () => void,
};

class KebabMenuOption extends React.Component<Props> {
  props: Props;

  static defaultProps = {
    children: undefined,
    className: undefined,
    disabled: false,
    icon: undefined,
    link: undefined,
    onClick: undefined,
    onItemClick: noop,
  };

  handleItemClick = () => {
    this.props.onItemClick();
    if (this.props.onClick) {
      this.props.onClick();
    }
  };

  render() {
    const {
      className,
      classes,
      children,
      disabled,
      icon,
      link,
    } = this.props;

    return (
      <Tappable
        className={classNames(classes.kebabItem, className, { disabled })}
        component={link ? RewriteLink : 'div'}
        onTap={this.handleItemClick}
        to={link}
        stopPropagation
        preventDefault
      >
        <Icon type={icon} className={classes.kebabIcon} />
        {children}
      </Tappable>
    );
  }
}

function applyStyles(theme: Theme) {
  return {
    kebabItem: {
      padding: [5, 20],
      transition: 'opacity 0.2s',
      color: theme.color.white,
      fontSize: theme.fontSize.default,
      display: 'flex',
      alignItems: 'center',
      opacity: 0.8,
      fontSmoothing: 'antialiased',
      '&:first-of-type': {
        paddingTop: 10,
      },
      '&:last-child': {
        paddingBottom: 10,
      },
      ...hover({
        opacity: 1,
      }),
      '&.disabled': {
        color: theme.color.basis4,
        cursor: 'not-allowed !important',
      },
    },
    kebabIcon: {
      marginRight: 10,
    },
  };
}

export default useSheet(applyStyles)(KebabMenuOption);
